<template>
  <div id="simple-calendar-app">

    <vs-popup class="warning-no-modules" title="Atenção!" :active.sync="warningNoModules">
      <p>Você não possui modulos do tipo calendário. Crie módulos do tipo calendário para utilizar o recurso.</p>
    </vs-popup>

    <div class="vx-card no-scroll-content">
      <calendar-view
        :key="calendarKey"
        ref="calendar"
        :disabled="true"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="calendarData.events"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">
          <!-- <div class="vx-card__header mb-6"><div class="vx-card__title"><h4 class="">{{ calendarData.name }}</h4></div></div> -->
          <div class="vx-row no-gutter">
            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button icon-pack="feather" :disabled="noModules" icon="icon-plus" @click="promptAddNewEvent(new Date())">Adicionar</vs-button>
            </div>
            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">
                  {{ showDate | month }}
                </span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarData.calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :style="{'background-color': label.color}"></div>
                      <span>{{ label.text }}</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
        :key="addPromptKey"
        class="calendar-event-dialog"
        title="Adicionar Evento"
        accept-text= "Adicionar Evento"
        cancel-text = "Cancelar"
        @accept="addEvent"
        :is-valid="validFormAdd"
        :active.sync="activePromptAddEvent">

        <div class="calendar__label-container flex">

          <vs-chip v-if="labelLocal != 'none'" class="text-white" :style="{'background-color': calendarData.labelColors[labelLocal]}">{{ calendarData.labelObject[labelLocal] }}</vs-chip>

          <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">

            <feather-icon icon="TagIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>

            <vs-dropdown-menu style="z-index: 200001">
              <vs-dropdown-item v-for="(label, index) in calendarData.calendarLabels" :key="index" @click="labelLocal = label.value">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :style="{'background-color': label.color}"></div>
                  <span>{{ label.text }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

        </div>

        <div v-show="showAddForm">

          <div class="mt-2" v-for="fieldItem in localForm" :key="fieldItem.hash">
            <small class="date-label mb-0" v-if="fieldItem.type_id === 1 || fieldItem.type_id === 8 || fieldItem.type_id === 19 || fieldItem.type_id === 24 || fieldItem.type_id === 25">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
            <vs-input v-if="fieldItem.type_id === 1" v-model="addData.fieldModel[fieldItem.hash]" :name="fieldItem.name" v-validate="fieldItem.mandatory ? 'required' : ''" class="w-full mt-0" :placeholder="fieldItem.title"></vs-input>
            <vs-input v-else-if="fieldItem.type_id === 8" v-model="addData.fieldModel[fieldItem.hash]" :name="fieldItem.name" v-validate="fieldItem.mandatory ? 'required' : ''" class="w-full" :placeholder="fieldItem.title"></vs-input>

            <div class="my-4" v-else-if="fieldItem.type_id === 12">
              <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
              <datepicker :format="customFormat(fieldItem.hash)" :language="langBr" :disabledDates="disabledDatesTo" v-model="addData.fieldModel[fieldItem.hash]" :name="fieldItem.name"></datepicker>
            </div>

            <div class="my-4" v-else-if="fieldItem.type_id === 13">
              <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
              <flat-pickr :placeholder="fieldItem.placeholder" :value="''" v-model="addData.fieldModel[fieldItem.hash]" :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', enableSeconds: true, time_24hr: true }" class="w-full" />
            </div>

            <div class="w-full mb-0" v-if="fieldItem.type_id === 17">
              <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
              <div class="vx-input-group-default w-full">
                <div>
                  <div class="w-full vs-component vs-con-input-label vs-input inputx vs-input-primary">
                    <div class="vs-con-input">
                      <the-mask :type="'text'" :name="fieldItem.name" :placeholder="fieldItem.placeholder" v-model="addData.fieldModel[fieldItem.hash]" :mask="'##:##:##'" class="vs-inputx vs-input--input normal hasValue need-style-placeholder" style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
                    </div>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>

            <div data-v-13a23bd0="" v-else-if="fieldItem.type_id === 19" class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08); "><!----><textarea style="height: 150px;!important" class="vs-textarea" v-model="addData.fieldModel[fieldItem.hash]" :name="fieldItem.name" :placeholder="fieldItem.placeholder" :maxlength="fieldItem.length ? fieldItem.length : 1000000"></textarea></div>

            <v-select v-else-if="fieldItem.type_id == 24 && fieldItem.name == 'assigned_to_id'" v-model="addData.fieldModel[fieldItem.hash]" :clearable="false" :options="optionFieldModel[fieldItem.hash]" @input="selectGroupChange($event, fieldItem.hash)" >
              <template v-slot:option="option">
                <span v-if="option.groupLevel === 1" style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;" onclick="return">{{ option.label }}</span>
                <span v-else>{{ option.label }}</span>
              </template>
            </v-select>

            <v-select v-else-if="fieldItem.type_id == 25" v-model="addData.fieldModel[fieldItem.hash]" :options="optionFieldModel[fieldItem.hash]" />

          </div>

        </div>

    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-prompt
        :key="editPromptKey"
        class="calendar-event-dialog"
        title="Editar Evento"
        accept-text= "Enviar"
        cancel-text = "Remover"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent"
        :is-valid="validFormEdit"
        :active.sync="activePromptEditEvent">

        <div class="calendar__label-container flex">

          <vs-chip v-if="labelLocal != 'none'" class="text-white" :style="{'background-color': calendarData.labelColors[labelLocal]}">{{ calendarData.labelObject[labelLocal] }}</vs-chip>

        </div>

        <div class="mt-2" v-for="fieldItem in editLocalForm" :key="fieldItem.hash">
          <small class="date-label mb-0" v-if="fieldItem.type_id === 1 || fieldItem.type_id === 8 || fieldItem.type_id === 19 || fieldItem.type_id === 24 || fieldItem.type_id === 25">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
          <vs-input v-if="fieldItem.type_id === 1" v-model="editData.fieldModel[fieldItem.hash]" :name="fieldItem.name" v-validate="fieldItem.mandatory ? 'required' : ''" class="w-full mt-0" :placeholder="fieldItem.title"></vs-input>
          <vs-input v-else-if="fieldItem.type_id === 8" v-model="editData.fieldModel[fieldItem.hash]" :name="fieldItem.name" v-validate="fieldItem.mandatory ? 'required' : ''" class="w-full" :placeholder="fieldItem.title"></vs-input>

          <div class="my-4" v-else-if="fieldItem.type_id === 12">
            <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
            <datepicker :format="customEditFormat(fieldItem.hash)" :language="langBr" :disabledDates="disabledDatesTo" v-model="editData.fieldModel[fieldItem.hash]" :name="fieldItem.name"></datepicker>
          </div>

          <div class="my-4" v-else-if="fieldItem.type_id === 13">
            <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
            <flat-pickr :placeholder="fieldItem.placeholder" :value="''" v-model="editData.fieldModel[fieldItem.hash]" :config="{ enableTime: true, dateFormat: 'd/m/Y H:i:S', enableSeconds: true, time_24hr: true }" class="w-full" />
          </div>

          <div class="w-full mb-0" v-if="fieldItem.type_id === 17">
            <small class="date-label">{{ fieldItem.title }} <span class="mandatory-field" v-if="fieldItem.mandatory"> *</span></small>
            <div class="vx-input-group-default w-full">
              <div>
                <div class="w-full vs-component vs-con-input-label vs-input inputx vs-input-primary">
                  <div class="vs-con-input">
                    <the-mask :type="'text'" :name="fieldItem.name" :placeholder="fieldItem.placeholder" v-model="editData.fieldModel[fieldItem.hash]" :mask="'##:##:##'" class="vs-inputx vs-input--input normal hasValue need-style-placeholder" style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
                  </div>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div data-v-13a23bd0="" v-else-if="fieldItem.type_id === 19" class="vs-component vs-con-textarea vs-textarea-primary" style="border: 1px solid rgba(0, 0, 0, 0.08); "><!----><textarea style="height: 150px;!important" class="vs-textarea" v-model="editData.fieldModel[fieldItem.hash]" :name="fieldItem.name" :placeholder="fieldItem.placeholder" :maxlength="fieldItem.length ? fieldItem.length : 1000000"></textarea></div>

          <v-select v-else-if="fieldItem.type_id == 24 && fieldItem.name == 'assigned_to_id'" v-model="editData.fieldModel[fieldItem.hash]" :clearable="false" :options="optionFieldModel[fieldItem.hash]" @input="selectGroupChange($event, fieldItem.hash)" >
            <template v-slot:option="option">
              <span v-if="option.groupLevel === 1" style="font-weight: bold!important; margin-left: -8px!important; cursor: default!important;" onclick="return">{{ option.label }}</span>
              <span v-else>{{ option.label }}</span>
            </template>
          </v-select>

          <v-select v-else-if="fieldItem.type_id == 25" v-model="editData.fieldModel[fieldItem.hash]" :options="optionFieldModel[fieldItem.hash]" />

        </div>

    </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import { performFetch } from '../../../helpers'
require('vue-simple-calendar/static/css/default.css')

import Datepicker from 'vuejs-datepicker'
import { en, he, ptBR } from 'vuejs-datepicker/src/locale'
import * as langs from 'vuejs-datepicker/src/locale'

import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    flatPickr,
    vSelect
  },
  data () {
    return {
      addPromptKey: Math.random(),
      editPromptKey: Math.random(),
      calendarKey: Math.random(),
      currentMandatoryFields: [],
      warningNoModules: false,
      noModules: false,
      currentEventToEdit: {},
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'd-m-Y H:i'
      },
      addData: {
        fieldModel: {}
      },
      editData: {
        fieldModel: {}
      },
      optionFieldModel: {},
      fieldType: {},
      fieldTitle: {},
      fieldName: {},

      showAddForm: false,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      editLabelLocal: 'none',
      localForm: [],
      editLocalForm: [],
      forms: {},
      moduleHashs: {},
      moduleFields: {},

      langHe: he,
      langEn: en,
      langBr: ptBR,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,
      calendarClasses: [],

      calendarViewTypes: [
        {
          label: 'Mês',
          val: 'month'
        },
        {
          label: 'Semana',
          val: 'week'
        }
      ],
      calendarData: {
        name: '',
        events: [],
        calendarLabels: [],
        labelColors: {},
        labelObject: {}
      }
    }
  },
  computed: {
    validateAddEvent() {


    },
    simpleCalendarEvents () {
      return this.$store.state.calendar.events
    },
    validFormAdd () {
      if(this.labelLocal === 'none') {
        return false
      }

      if(this.currentMandatoryFields.some(item => this.addData.fieldModel[item] === '' || this.addData.fieldModel[item] === null)) {
        return false
      } else if(Array.isArray(this.localForm) && this.localForm.length > 0 && this.addData.fieldModel.hasOwnProperty(this.localForm.find(x => x.name === 'start_date').hash) && new Date(this.addData.fieldModel[this.localForm.find(x => x.name === 'start_date').hash]) > new Date(this.addData.fieldModel[this.localForm.find(x => x.name === 'end_date').hash])) {
        return false
      }

      return true
    },
    validFormEdit () {

      if(this.currentMandatoryFields.some(item => this.editData.fieldModel[item] === '' || this.editData.fieldModel[item] === null)) {
        return false
      }
      else if(Array.isArray(this.localForm) && this.localForm.length > 0 && this.editData.fieldModel.hasOwnProperty(this.localForm.find(x => x.name === 'start_date').hash) && new Date(this.editData.fieldModel[this.localForm.find(x => x.name === 'start_date').hash]) > new Date(this.editData.fieldModel[this.localForm.find(x => x.name === 'end_date').hash])) {
        return false
      }
      // else if(this.editData.fieldModel[this.localForm.find(x => x.name === 'start_date').hash] > this.editData.fieldModel[this.localForm.find(x => x.name === 'end_date').hash]) {
      //   return false
      // }

      return true
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    // calendarLabels () {
    //   return this.$store.state.calendar.eventLabels
    // },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  watch: {
    activePromptAddEvent(value) {
      if(!value) {
        this.localForm = []
        this.startDate = null
        this.endDate = null
      }
    },
    activePromptEditEvent(value) {
      if(!value) {
        this.localForm = []
        this.startDate = null
        this.endDate = null
      }
    },
    calendarView(value) {
      this.$vs.loading({type: 'default'})
      this.setClasses()
    },
    labelLocal (value) {
      if(value !== 'none') {
        this.localForm = this.forms[value]
        this.showAddForm = true
        this.currentMandatoryFields = []
        if(Array.isArray(this.localForm)) {
          this.localForm.forEach(item => {
            if(item.mandatory && item.name !== 'assigned_to_id') {
              this.currentMandatoryFields.push(item.hash)
            }
          })
        }

        if(this.startDate !== '' && this.startDate !== null) {
          this.addData.fieldModel[this.localForm.find(x => x.name === 'start_date').hash] = this.startDate
          this.addData.fieldModel[this.localForm.find(x => x.name === 'end_date').hash] = this.startDate
        }
      }
    }
  },
  methods: {
    customFormat(fieldHash) {

      let date = this.addData.fieldModel[fieldHash]
      const dateObject = new Date(Date.parse(date))

      let month = (dateObject.getMonth() + 1)

      if(month < 10) {
        month = '0' + month
      }

      let day = dateObject.getDate()

      if(day < 10) {
        day = '0' + day
      }

      return `${day}/${month}/${dateObject.getFullYear()}`
    },
    customEditFormat(fieldHash) {

      if(typeof this.editData.fieldModel[fieldHash] === 'string' && this.editData.fieldModel[fieldHash].split('-').length === 3) {

        let year = this.editData.fieldModel[fieldHash].split('-')[0]
        let month = this.editData.fieldModel[fieldHash].split('-')[1]
        let day = this.editData.fieldModel[fieldHash].split('-')[2]

        return `${day}/${month}/${year}`

      } else {
        let date = this.editData.fieldModel[fieldHash]
        const dateObject = new Date(Date.parse(date))

        let month = (dateObject.getMonth() + 1)

        if(month < 10) {
          month = '0' + month
        }

        let day = dateObject.getDate()

        if(day < 10) {
          day = '0' + day
        }

        return `${day}/${month}/${dateObject.getFullYear()}`
      }
    },
    setClasses() {
      setTimeout(() => {
        this.calendarClasses.forEach(classItem => {

          document.querySelectorAll('.' + classItem).forEach(item => {
            item.style.background = this.calendarData.labelColors[classItem]
          })
        })

        this.$vs.loading.close()
      }, 300)
    },
    checkIfStringIsDateTime (string) {

      try {
        if ((string.split('/').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    checkIfStringIsDate (string) {
      try {
        if ((string.split('/').length - 1) == 2 && (string.length === 10)) {
          return true
        } else if(Date.parse(string) > 100) {
          console.log('opaaa')
          // new Date(Date.parse(date))
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    selectGroupChange (val, fieldHash, assignTypeId) {
      if (val.groupLevel === 1) {
        this.addDatafieldModel[fieldHash] = null
      }
    },
    async getCalendarData() {

      this.calendarKey = Math.random()

      this.$vs.loading({type: 'default'})

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_calendar_data',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'get_calendar_data',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
        .then(async (response) => {
          if(response.status === 200) {
            await response.json().then(responseData => {

              if(responseData.calendars.length > 0) {
                this.calendarData.events = []
                this.calendarData.calendarLabels = []

                responseData.calendars.forEach(item => {

                  if(item.user_view) {
                    const normalizedCalendarName = item.title.split(' ')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") + '_key_' + Math.random().toString().split('.')[1]

                    this.calendarData.calendarLabels.push({
                      color: item.color,
                      text: item.title,
                      value: normalizedCalendarName
                    })

                    this.$set(this.calendarData.labelObject, normalizedCalendarName, item.title)

                    this.$set(this.calendarData.labelColors, normalizedCalendarName, item.color)

                    this.$set(this.moduleHashs, normalizedCalendarName, item.hash)

                    this.$set(this.forms, normalizedCalendarName, item.fields)

                    item.events.forEach(eventItem => {

                      let eventName = ''
                      let startDate = null
                      let endDate = null

                      eventItem.data.forEach(eventFieldItem => {
                        if(eventFieldItem.name === 'event_name') {
                          eventName = eventFieldItem.payload
                        } else if(eventFieldItem.name === 'start_date') {
                          startDate = eventFieldItem.payload
                        } else if(eventFieldItem.name === 'end_date') {
                          endDate = eventFieldItem.payload
                        }

                        if(eventFieldItem.type_id === 1 || eventFieldItem.type_id === 8 || eventFieldItem.type_id === 17 || eventFieldItem.type_id === 19) {
                          this.$set(this.editData.fieldModel, eventFieldItem.hash, '')
                        } else if(eventFieldItem.type_id === 12) {
                          this.$set(this.editData.fieldModel, eventFieldItem.hash, '')
                        } else if(eventFieldItem.type_id === 13) {
                          this.$set(this.editData.fieldModel, eventFieldItem.hash, '')
                        } else if(eventFieldItem.type_id === 24) {

                          this.$set(this.optionFieldModel, eventFieldItem.hash, eventFieldItem.options)

                          eventFieldItem.options.forEach(optionItem => {
                            if(optionItem.selected) {
                              this.$set(this.editData.fieldModel, eventFieldItem.hash, {value: optionItem.value, label: optionItem.label})
                            }
                          })

                        } else if(eventFieldItem.type_id === 25) {

                          this.$set(this.optionFieldModel, eventFieldItem.hash, eventFieldItem.options)

                          eventFieldItem.options.forEach(optionItem => {
                            if(optionItem.selected) {
                              this.$set(this.editData.fieldModel, eventFieldItem.hash, {value: optionItem.value, label: optionItem.label})
                            }
                          })
                        }
                      })

                      const eventObject = {
                        classes: ['event-success', normalizedCalendarName],
                        startDate: startDate,
                        endDate: endDate,
                        label: normalizedCalendarName,
                        title: eventName,
                        id: eventItem.identification,
                        fields: eventItem.data
                      }

                      this.calendarData.events.push(eventObject)
                    })

                    item.fields.forEach(fieldItem => {

                      if(fieldItem.type_id === 1 || fieldItem.type_id === 8 || fieldItem.type_id === 17 || fieldItem.type_id === 19) {
                        this.$set(this.addData.fieldModel, fieldItem.hash, '')
                      } else if(fieldItem.type_id === 12) {
                        this.$set(this.addData.fieldModel, fieldItem.hash, '')
                      } else if(fieldItem.type_id === 13) {
                        this.$set(this.addData.fieldModel, fieldItem.hash, '')
                      } else if(fieldItem.type_id === 24) {

                        this.$set(this.optionFieldModel, fieldItem.hash, fieldItem.options)

                        fieldItem.options.forEach(optionItem => {
                          if(optionItem.selected) {
                            this.$set(this.addData.fieldModel, fieldItem.hash, {value: optionItem.value, label: optionItem.label})
                          }
                        })

                      } else if(fieldItem.type_id === 25) {

                        this.$set(this.optionFieldModel, fieldItem.hash, fieldItem.options)

                        fieldItem.options.forEach(optionItem => {
                          if(optionItem.selected) {
                            this.$set(this.addData.fieldModel, fieldItem.hash, {value: optionItem.value, label: optionItem.label})
                          }
                        })
                      }

                      if(this.moduleFields.hasOwnProperty(normalizedCalendarName)) {
                        this.moduleFields[normalizedCalendarName].push(fieldItem.hash)
                      } else {
                        this.$set(this.moduleFields, normalizedCalendarName, [])
                        this.moduleFields[normalizedCalendarName].push(fieldItem.hash)
                      }
                      this.$set(this.fieldTitle, fieldItem.hash, fieldItem.title)
                      this.$set(this.fieldName, fieldItem.hash, fieldItem.name)
                      this.$set(this.fieldType, fieldItem.hash, fieldItem.type_id)
                    })

                    this.calendarClasses.push(normalizedCalendarName)
                  }
                })

                if(this.calendarData.calendarLabels.length === 0) {
                  this.warningNoModules = true
                }

                // console.log(this.calendarData.calendarLabels)

                this.setClasses()
              } else {

                this.$vs.loading.close()
                this.warningNoModules = true
                this.noModules = true

              }
            })
          } else if(response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    async addEvent () {

      if(!this.validFormAdd) {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Ocorreu um erro ao salvar o evento. Atualize a página e tente novamente',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return
      }

      this.$vs.loading({type: 'default'})

      const newFieldData = {}

      Object.keys(this.addData.fieldModel).forEach(item => {

        if(this.moduleFields[this.labelLocal].includes(item)) {
          if(this.fieldType[item] !== 27) {
            if (this.addData.fieldModel[item] === '') {
              newFieldData[item] = null
            } else if (typeof this.addData.fieldModel[item] === 'object' && this.addData.fieldModel[item] !== null && this.fieldName[item] === 'assigned_to_id') {
              newFieldData[item] = this.addData.fieldModel[item]['value']
            } else if(typeof this.addData.fieldModel[item] === 'object' && this.addData.fieldModel[item] !== null && this.fieldType[item] === 24) {
              if(this.addData.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.addData.fieldModel[item]['value']
              }
            } else if(typeof this.addData.fieldModel[item] === 'object' && this.addData.fieldModel[item] !== null && this.fieldType[item] === 25) {
              if(this.addData.fieldModel[item]['value'] === 0) {
                newFieldData[item] = null
              } else {
                newFieldData[item] = this.addData.fieldModel[item]['value']
              }
            } else if (typeof this.addData.fieldModel[item] === 'string' && this.addData.fieldModel[item] !== null && this.fieldType[item] === 17) {
              if(this.addData.fieldModel[item].length === 6) {
                newFieldData[item] = this.addData.fieldModel[item].slice(0, 2) + ':' + this.addData.fieldModel[item].slice(2, 4) + ':' + this.addData.fieldModel[item].slice(4, 6)
              } else if(this.addData.fieldModel[item].length === 4) {
                newFieldData[item] = this.addData.fieldModel[item].slice(0, 2) + ':' + this.addData.fieldModel[item].slice(2, 4)
              }
            } else if(this.fieldType[item] === 12) {

              if(this.addData.fieldModel[item] !== null) {

                if(typeof this.addData.fieldModel[item] === 'object') {

                  let dateObject = this.addData.fieldModel[item]

                  dateObject = new Date(dateObject)

                  if(dateObject instanceof Date) {

                    const dateStr = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1) < 10 ? '0' + (dateObject.getMonth() + 1) : (dateObject.getMonth() + 1)}-${dateObject.getDate() < 10 ? '0' + dateObject.getDate() : dateObject.getDate()}`

                    newFieldData[item] = dateStr

                  }

                } else if(typeof this.addData.fieldModel[item] === 'string') {

                  if(this.checkIfStringIsDate(this.addData.fieldModel[item])) {
                    const dateStr = this.addData.fieldModel[item].split(' ')[0].trim()
                    const hourStr = this.addData.fieldModel[item].split(' ')[1].trim()
                    newFieldData[item] = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]} ${hourStr}`
                  }

                }

              } else {

                newFieldData[item] = this.addData.fieldModel[item]

              }

            } else if(this.fieldType[item] === 13) {

              if(this.addData.fieldModel[item] !== null) {

                if(typeof this.addData.fieldModel[item] === 'object') {

                  let dateObject = this.addData.fieldModel[item]

                  dateObject = new Date(dateObject)

                  if(dateObject instanceof Date) {

                    const dateStr = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1) < 10 ? '0' + (dateObject.getMonth() + 1) : (dateObject.getMonth() + 1)}-${dateObject.getDate() < 10 ? '0' + dateObject.getDate() : dateObject.getDate()} ${dateObject.getHours() < 10 ? '0' + dateObject.getHours() : dateObject.getHours()}:${dateObject.getMinutes() < 10 ? '0' + dateObject.getMinutes() : dateObject.getMinutes()}:${dateObject.getSeconds() < 10 ? '0' + dateObject.getSeconds() : dateObject.getSeconds()}`

                    newFieldData[item] = dateStr

                  }

                } else if(typeof this.addData.fieldModel[item] === 'string') {
                  if(this.checkIfStringIsDateTime(this.addData.fieldModel[item])) {
                    const dateStr = this.addData.fieldModel[item].split(' ')[0].trim()
                    const hourStr = this.addData.fieldModel[item].split(' ')[1].trim()
                    newFieldData[item] = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]} ${hourStr}`
                  }
                }

              } else {
                newFieldData[item] = this.addData.fieldModel[item]
              }

            } else {

              newFieldData[item] = this.addData.fieldModel[item]
            }
          }
        }
      })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.moduleHashs[this.labelLocal],
        data: newFieldData
      }


      // await fetch(`${this.$store.state.auth.api_url}`, {
      //     method: 'POST', headers: {"Content-Type": "application/json"},
      //     body: JSON.stringify({
      //       command: 'add_module_row',
      //       parameters: requestBody
      //     })
      //   })
      await performFetch(this.$store.state.auth.api_url, {
            command: 'add_module_row',
            parameters: requestBody
          })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              await this.getCalendarData()

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status === 400) {
            this.$vs.loading.close()
            response.json().then((responseData) => {
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao salvar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'none'
    },
    promptAddNewEvent (date) {
      this.disabledFrom = false
      this.addNewEventDialog(date)
    },
    addNewEventDialog (date) {
      this.clearFields()
      this.startDate = date
      this.endDate = date
      this.activePromptAddEvent = true
    },
    openAddNewEvent (date) {

      if(this.noModules) {
        return
      }

      this.disabledFrom = true
      this.addNewEventDialog(date)
    },
    openEditEvent (event) {

      if(this.noModules) {
        return
      }

      const originalEvent = event.originalEvent

      this.currentEventToEdit = originalEvent

      this.labelLocal = originalEvent.label

      originalEvent.fields.forEach(fieldItem => {
        if(fieldItem.type_id === 1 || fieldItem.type_id === 8 || fieldItem.type_id === 17 || fieldItem.type_id === 19) {
          this.$set(this.editData.fieldModel, fieldItem.hash, fieldItem.payload)
        } else if(fieldItem.type_id === 12) {

          let newPayload = ''

          // if(fieldItem.payload !== '' && fieldItem.payload !== null) {

          //   console.log(fieldItem.payload)

          //   newPayload = `${fieldItem.payload.split('-')[2]}/${fieldItem.payload.split('-')[1]}/${fieldItem.payload.split('-')[0]}`
          // }

          // console.log(newPayload)

          newPayload = fieldItem.payload


          this.$set(this.editData.fieldModel, fieldItem.hash, newPayload)
        } else if(fieldItem.type_id === 13) {

          let formattedPayload = fieldItem.payload

          const date = formattedPayload.split(' ')[0].trim()

          const hour = formattedPayload.split(' ')[1].trim()

          formattedPayload = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${hour}`

          this.$set(this.editData.fieldModel, fieldItem.hash, formattedPayload)

        } else if(fieldItem.type_id === 24) {

          this.$set(this.optionFieldModel, fieldItem.hash, fieldItem.options)

          fieldItem.options.forEach(optionItem => {
            if(optionItem.selected) {
              this.$set(this.editData.fieldModel, fieldItem.hash, {value: optionItem.value, label: optionItem.label})
            }
          })

        } else if(fieldItem.type_id === 25) {

          this.$set(this.optionFieldModel, fieldItem.hash, fieldItem.options)

          fieldItem.options.forEach(optionItem => {
            if(optionItem.selected) {
              this.$set(this.editData.fieldModel, fieldItem.hash, {value: optionItem.value, label: optionItem.label})
            }
          })
        }
      })
      this.editLocalForm = this.forms[originalEvent.label]
      this.activePromptEditEvent = true
      // const e = this.$store.getters['calendar/getEvent'](event.id)
      // this.id = e.id
      // this.title = e.title
      // this.startDate = e.startDate
      // this.endDate = e.endDate
      // this.url = e.url
      // this.labelLocal = e.label
    },
    async editEvent () {

      this.$vs.loading({type: 'default'})

      const currentEvent = this.currentEventToEdit

      const newFieldData = {}

        Object.keys(this.editData.fieldModel).forEach((item) => {

          if(this.moduleFields[this.labelLocal].includes(item)) {
            if(this.fieldType[item] !== 27) {
              if (this.editData.fieldModel[item] === '') {
                newFieldData[item] = null
              } else if (typeof this.editData.fieldModel[item] === 'object' && this.editData.fieldModel[item] !== null && this.fieldName[item] === 'assigned_to_id') {
                newFieldData[item] = this.editData.fieldModel[item]['value']
              } else if(typeof this.editData.fieldModel[item] === 'object' && this.editData.fieldModel[item] !== null && this.fieldType[item] === 24) {
                if(this.editData.fieldModel[item]['value'] === 0) {
                  newFieldData[item] = null
                } else {
                  newFieldData[item] = this.editData.fieldModel[item]['value']
                }
              } else if(typeof this.editData.fieldModel[item] === 'object' && this.editData.fieldModel[item] !== null && this.fieldType[item] === 25) {
                if(this.editData.fieldModel[item]['value'] === 0) {
                  newFieldData[item] = null
                } else {
                  newFieldData[item] = this.editData.fieldModel[item]['value']
                }
              } else if (typeof this.editData.fieldModel[item] === 'string' && this.editData.fieldModel[item] !== null && this.fieldType[item] === 17) {
                if(this.editData.fieldModel[item].length === 6) {
                  newFieldData[item] = this.editData.fieldModel[item].slice(0, 2) + ':' + this.editData.fieldModel[item].slice(2, 4) + ':' + this.editData.fieldModel[item].slice(4, 6)
                } else if(this.editData.fieldModel[item].length === 4) {
                  newFieldData[item] = this.editData.fieldModel[item].slice(0, 2) + ':' + this.editData.fieldModel[item].slice(2, 4)
                }
              } else if(this.fieldType[item] === 12) {

                if((new Date(Date.parse(this.editData.fieldModel[item]))).getTime() > 0) {
                  let date = this.editData.fieldModel[item]
                  const dateObject = new Date(Date.parse(date))

                  let month = (dateObject.getMonth() + 1)

                  if(month < 10) {
                    month = '0' + month
                  }

                  let day = dateObject.getDate()

                  if(day < 10) {
                    day = '0' + day
                  }

                  newFieldData[item] = `${dateObject.getFullYear()}-${month}-${day}`
                }

              } else {
                const isDateTime = this.checkIfStringIsDateTime(this.editData.fieldModel[item])

                if (isDateTime) {
                  const dateStr = this.editData.fieldModel[item].split(' ')[0].trim()
                  const hourStr = this.editData.fieldModel[item].split(' ')[1].trim()
                  newFieldData[item] = `${dateStr.split('/')[2]}-${dateStr.split('/')[1]}-${dateStr.split('/')[0]} ${hourStr}`
                } else {

                  const isDate = this.checkIfStringIsDate(this.editData.fieldModel[item])

                  if (isDate) {
                    newFieldData[item] = `${this.editData.fieldModel[item].split('/')[2]}-${this.editData.fieldModel[item].split('/')[1]}-${this.editData.fieldModel[item].split('/')[0]}`
                  } else {

                    newFieldData[item] = this.editData.fieldModel[item]
                  }
                }
              }
            }
          }
        })

        const requestBody = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.moduleHashs[this.labelLocal],
          data: newFieldData,
          row_hash: currentEvent.id
        }

        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'update_module_row',
        //     parameters: requestBody
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
            command: 'update_module_row',
            parameters: requestBody
          })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              await this.getCalendarData()

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status === 400) {
            response.json().then((responseData) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })
          } else if (response.status == 403) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção',
              text: 'Você não tem permissão para editar registros neste módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao atualizar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    removeEvent () {
      this.currentEventToDelete = this.currentEventToEdit
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Exclusão',
        text: 'Você tem certeza que deseja excluir este evento ?',
        accept: this.deleteEvent,
        acceptText: 'Excluir'
      })
    },
    async deleteEvent() {

      this.$vs.loading({ type: 'default' })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.moduleHashs[this.currentEventToDelete.label],
        row_hash: this.currentEventToDelete.id
      }

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_module_row',
      //     parameters: requestBody
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'delete_module_row',
          parameters: requestBody
        })
        .then(async (response) => {
          console.log(response)
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })

              this.currentEventToDelete = {}
              this.currentEventToEdit = {}

              this.getCalendarData()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status == 403) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção!',
              text: 'Você não tem permissão para deletar registros neste módulo!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao deletar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async eventDragged (event, date) {

      this.$vs.loading({type: 'default'})

      const startDateFieldHash = event.originalEvent.fields.find(x => x.name === 'start_date').hash
      const endDateFieldHash = event.originalEvent.fields.find(x => x.name === 'end_date').hash

      const oldDate = event.startDate
      const newDate = date
      const endDate = event.endDate

      const originalHours = this.formatTime(oldDate.getHours(), oldDate.getMinutes(), oldDate.getSeconds())

      oldDate.setHours(0, 0, 0)
      newDate.setHours(0, 0, 0)

      let diffDays = 0

      if(newDate.getDate() === oldDate.getDate()) {
        //
      } else if(newDate > oldDate) {
        const diffTime = Math.abs(newDate - oldDate)
        diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      } else if(newDate < oldDate) {
        const diffTime = Math.abs(newDate - oldDate)
        diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        diffDays = diffDays * -1
      }

      if(diffDays !== 0) {

        if(diffDays < 0) {
          diffDays = Math.abs(diffDays)
          endDate.setDate(endDate.getDate() - diffDays)
        } else {
          endDate.setDate(endDate.getDate() + (diffDays * 1))
        }

        const fieldsData = {}

        const newDateStr = this.formatDate(newDate.getFullYear(), (newDate.getMonth() + 1), newDate.getDate())
        const endDateStr = this.formatDate(endDate.getFullYear(), (endDate.getMonth() + 1), endDate.getDate())
        const endDateHours = this.formatTime(endDate.getHours(), endDate.getMinutes(), endDate.getSeconds())

        fieldsData[startDateFieldHash] = `${newDateStr} ${originalHours}`
        fieldsData[endDateFieldHash] = `${endDateStr} ${endDateHours}`


        const requestBody = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.moduleHashs[event.originalEvent.label],
          data: fieldsData,
          row_hash: event.id
        }

        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'update_module_row',
        //     parameters: requestBody
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
            command: 'update_module_row',
            parameters: requestBody
          })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              await this.getCalendarData()

              this.$vs.loading.close()

              this.$vs.notify({
                title: 'Operação Realizada!',
                text: response.message,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if (response.status === 400) {
            response.json().then((responseData) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Operação não realizada!',
                text: responseData.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            })
          } else if (response.status == 403) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Atenção',
              text: 'Você não tem permissão para editar registros neste módulo',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao atualizar o registro',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
          .catch((e) => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: e.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            throw new Error(e.message)
          })
      }
      // this.$store.dispatch('calendar/eventDragged', {event, date})
    },
    formatTime(hour, minute, second) {

      if(hour <= 9) {
        hour = '0' + hour
      }

      if(minute <= 9) {
        minute = '0' +  minute
      }

      if(second <= 9) {
        second = '0' +  second
      }

      return `${hour}:${minute}:${second}`
    },
    formatDate(year, month, day){
      if(year <= 9) {
        year = '0' + year
      }

      if(month <= 9) {
        month = '0' +  month
      }

      if(day <= 9) {
        day = '0' +  day
      }

      return `${year}-${month}-${day}`
    },
  },
  mounted() {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.querySelector('.vx-card').style.borderRadius = '5px'
  },
  async created () {
    await this.getCalendarData()
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch('calendar/fetchEvents')
    this.$store.dispatch('calendar/fetchEventLabels')
  },
  beforeDestroy () {
    this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";

.mandatory-field {
  color: rgb(216, 50, 50)!important;
}
</style>
